import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { chartJsDefaultTooltip } from 'helpers/chartjs-utils';
import { useAppContext } from 'providers/AppProvider';
import React from 'react';
import PropTypes from 'prop-types';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';

function LineChart({ dataDB, width, height }) {
  const { getThemeColor } = useAppContext();

  const data = {
    labels: dataDB?.labels,
    datasets: [
      {
        type: 'line',
        label: dataDB?.legend,
        borderColor: getThemeColor('primary'),
        borderWidth: 2,
        fill: false,
        data: dataDB?.datasets[0]?.data,
        tension: 0.3
      }
    ]
  };

  const options = {
    plugins: {
      tooltip: chartJsDefaultTooltip(getThemeColor),
      legend: {
        labels: {
          color: getThemeColor('gray-500')
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: getThemeColor('gray-500')
        },
        grid: {
          color: getThemeColor('gray-300'),
          drawBorder: false
        }
      },
      y: {
        ticks: {
          color: getThemeColor('gray-500')
        },
        grid: {
          color: getThemeColor('gray-300'),
          drawBorder: false
        }
      }
    }
  };

  return (
    <Card className="h-md-100">
      <Card.Header className="pb-0">
        <h6 className="mb-0 mt-2">
          Fill Rate
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                Calculated according to selected date jobs
              </Tooltip>
            }
          >
            <span>
              <FontAwesomeIcon
                icon={['far', 'question-circle']}
                transform="shrink-1"
                className="ms-1 text-400"
                id="weeklySalesTooltip"
              />
            </span>
          </OverlayTrigger>
        </h6>
      </Card.Header>

      <Card.Body as={Flex} alignItems="end" justifyContent="between">
        <Line
          data={data}
          options={options}
          style={{ width: width, height: height }}
        />
      </Card.Body>
    </Card>
  );
}

export default LineChart;

LineChart.propTypes = {
  dataDB: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any
};
